import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'

@Injectable()
export class DiscountGroupsService {
  constructor(private http: HttpClient) {}

  public fetchDiscountGroups(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/discountGroup/list`
    return this.http.post(url, params)
  }
  public fetchDiscountGroup(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/discountGroup/${id}`
    return this.http.get(url, {})
  }

  public deleteDiscountGroup(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/discountGroup/${id}`
    return this.http.delete(url)
  }

  public createDiscountGroup(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/discountGroup`
    return this.http.post(url, params)
  }

  public updateDiscountGroup(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/discountGroup/${id}`
    return this.http.put(url, params)
  }
}
